import React, { useState } from 'react';
import ExportDetail from './ExportMenu/ExportDetail';
import { useNavigate, useParams } from 'react-router-dom';
import { useExportShipmentDetails } from './ExportMenu/Hook/useExportShipmentDetails';
import CustomCollapse from '../common/CustomCollapse';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CustomLoader from '../common/CustomLoader';
import { ExportTasks } from './ExportMenu/ExportTasks';
import { ExportCall } from './ExportMenu/ExportCall';
import { ExportNotes } from './ExportMenu/ExportNotes';

export default function PersistentDrawerLeft() {

    const [open, setOpen] = React.useState(true);
    const [activeTab, setActiveTab] = React.useState('Overview'); // Track active tab
    const navigate = useNavigate();
    const { exportShipmentId } = useParams();

    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);
    if (!shipmentDetails) {
        return <p> <CustomLoader open={shipmentLoading} /></p>;
    }

    const firstName = shipmentDetails.user.firstName;
    const lastName = shipmentDetails.user.lastName;
    const email = shipmentDetails.user.email;
    const mobile =
        shipmentDetails?.user?.mobile && shipmentDetails?.user?.phonecode?.phonecode
            ? `+${shipmentDetails.user.phonecode.phonecode}${shipmentDetails.user.mobile}`
            : shipmentDetails?.user?.mobile || '';

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const initial = shipmentDetails.customer.clientCompanyName ? shipmentDetails.customer.clientCompanyName.charAt(0).toUpperCase() : '';

    const handleBackClick = () => {
        navigate("/app/export/shipement");
    };

    const adminData = [
        {
            title: "Owner",
            defaultExpanded: false,
            details: [
                { label: 'Owner', value: `${firstName || ''} ${lastName || ''}`.trim() },
                { label: 'Email', value: email, sm: 12, md: 12 },
                { label: 'Mobile', value: mobile, sm: 12, md: 12 },

            ],
        },
    ];

    return (
        <>
            <div>
                <ExportDetail />
                <br />
                <ExportCall exportShipmentId={exportShipmentId} data={shipmentDetails} />
                <br />
                <ExportTasks exportShipmentId={exportShipmentId} data={shipmentDetails} />
                <br />
                <ExportNotes exportShipmentId={exportShipmentId} data={shipmentDetails} />
                <br />
                <CustomCollapse Icon={PersonOutlineOutlinedIcon} data={adminData} />
            </div >
        </>
    );
}

